exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-container[data-v-78ae7c30]{position:absolute;top:0;left:0;bottom:0;right:0;z-index:10;background-color:hsla(0,0%,100%,.8)}.loader-container .loader[data-v-78ae7c30]{position:absolute;top:50%;margin-top:-24px;left:50%;margin-left:-24px;width:48px;height:48px;border:5px solid #474747;border-bottom-color:transparent;border-radius:50%;display:inline-block;box-sizing:border-box;animation:rotation-78ae7c30 1s linear infinite}@keyframes rotation-78ae7c30{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
